import React, { PureComponent } from 'react';
import classnames from 'classnames';

export default class ChartHeader extends PureComponent {
  render() {
    const { title, trend = null, total, totalSign = '' } = this.props;

    return (
      <div className="card__title">
        {total && (
          <div className="total-value">
            {total}
            {totalSign}
            {trend && (
              <span className={classnames('trend', { negative: trend < 0 })}>
                <i
                  className={classnames('fas', {
                    'fas fa-level-down-alt': trend < 0,
                    'fas fa-level-up-alt': trend > 0
                  })}
                />
                <span className="trend-value">{trend}%</span>
              </span>
            )}
          </div>
        )}
        <div className="title">{title}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/chart/ChartHeader.js